import React, { useContext, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ThemeContext } from '../themeProvider/ThemeProvider';

import { AdminMenu, HeaderInfo } from 'src/features';

import { ROUTE } from 'src/constants';

import { GreenEllipseBottom } from 'src/assets';
import './adminLayout.scss';

export const AdminLayout = (props) => {
  const { children } = props;

  const { toggleTheme } = useContext(ThemeContext);
  const { i18n } = useTranslation();

  const { pathname } = useLocation();

  useEffect(() => {
    i18n.changeLanguage('ru');

    if (pathname?.includes('/dashboard')) {
      toggleTheme('light');
    }
  }, [i18n, pathname, toggleTheme]);

  const isAdminLogin = pathname === ROUTE.ADMIN.LOGIN.MAIN;

  const adminStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <div className="admin-layout">
      <div className="admin-layout__wrapper">
        <HeaderInfo />
        <div className="admin-layout__main__content">
          {!isAdminLogin ? <AdminMenu /> : null}
          <div className="admin-layout__content" style={isAdminLogin ? adminStyles : {}}>
            {children || <Outlet />}
          </div>
        </div>
      </div>

      <img src={GreenEllipseBottom} alt={GreenEllipseBottom} className="admin-layout__image-1" />
    </div>
  );
};
